export default __webpack_public_path__ + "static/media/EmpDashboard.a7335fc0.svg";